var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "params-form" },
        [
          _c(
            "a-form-model",
            {
              ref: "searchForm",
              attrs: { layout: "inline", model: _vm.formState },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "受检单位名称", prop: "name" } },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "18" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "name", $$v)
                              },
                              expression: "formState.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("a-col", { attrs: { span: "1" } }),
                      _c(
                        "a-col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onChoiceNeedCheckModalOpen },
                            },
                            [_vm._v("选择")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "监测环节", prop: "link" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "100px" },
                    },
                    [
                      _c("a-ext-task-link-select", {
                        attrs: { "project-id": _vm.projectId },
                        model: {
                          value: _vm.formState.link,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "link", $$v)
                          },
                          expression: "formState.link",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "抽样品种", prop: "pickType" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "100px" },
                    },
                    [
                      _c("a-ext-task-produce-select", {
                        attrs: { "project-id": _vm.projectId },
                        model: {
                          value: _vm.formState.pickType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "pickType", $$v)
                          },
                          expression: "formState.pickType",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "抽样数分配", prop: "pickCount" } },
                [
                  _c("a-input-number", {
                    attrs: { id: "inputNumber", min: 1, max: 10000 },
                    model: {
                      value: _vm.formState.pickCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "pickCount", $$v)
                      },
                      expression: "formState.pickCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                [
                  _c(
                    "a-space",
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.onAddTarget },
                        },
                        [_vm._v("添加至任务列表")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-content" },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { width: "650px", display: "inline-block" },
              },
              [
                _vm._v(" 监测项目管理 "),
                _vm.selectedRowCount
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "150px",
                          display: "inline-block",
                          "line-height": "20px",
                          color: "darkorange",
                        },
                      },
                      [_vm._v(" 共选择" + _vm._s(_vm.selectedRowCount) + "条 ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "350px",
                      display: "inline-block",
                      "line-height": "20px",
                      color: "darkgray",
                      "font-weight": "600",
                      "font-size": "14px",
                    },
                  },
                  [
                    _vm._v(
                      " 需分配任务数" +
                        _vm._s(_vm.total) +
                        "已分配任务数" +
                        _vm._s(_vm.done) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c(
            "a-config-provider",
            { attrs: { locale: _vm.locale } },
            [
              _c("a-table", {
                attrs: {
                  "data-source": _vm.dataSource,
                  columns: _vm.columns,
                  pagination: _vm.pagination,
                  loading: _vm.loading,
                  "row-key": "id",
                  scroll: { y: 500 },
                },
                on: { change: _vm.onPageChange },
                scopedSlots: _vm._u([
                  {
                    key: "caozuo",
                    fn: function (text, record) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "orange", cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(record)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.choiceNeedCheckModalVisable
        ? _c("choice-need-check-modal", {
            attrs: {
              visible: _vm.choiceNeedCheckModalVisable,
              param: _vm.choiceNeedCheckModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.choiceNeedCheckModalVisable = $event
              },
              dialogBack: _vm.onChoiceNeedCheckModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }